import React from "react";

import {makeStyles, withStyles} from "@material-ui/core/styles";


import Card from "../../components2/Card/Card";

import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";


import styles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import {getAccountSeries, getUserSubscribe} from "../../utils/request";
import {MineViewStudyTime} from "../components/mine_view_study_time";
import Success from "../../components/Typography/Success";
import CardBody from "../../components2/Card/CardBody";
import intl from "react-intl-universal";
import SVG from "react-inlinesvg";
import Rose from "../../components/Typography/Rose";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Close from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import Instruction from "../../components/Instruction/Instruction";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import copy from "copy-to-clipboard";
import {withSnackbar} from "notistack";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

class AccountSubscribe extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			imgSvg: require('../../assets/svg/subscribe_cat.svg'),
			isVip: this.props.data.userStatus,
			endDate: this.props.data.userSubscribeEndDate === "" ? '----/--/--' : this.props.data.userSubscribeEndDate,
			showDialog: false
		}
		this.initData();
	}

	initData = () => {
		// getUserSubscribe().then()
	};

	openDialog = () => {
		this.setState({
			showDialog: true
		})
	};

	closeDialog = () => {
		this.setState({
			showDialog: false
		})
	}


	render() {
		const {classes} = this.props;

		const copyInvite = () => {
			copy(this.props.data.invitationCode);
			this.props.enqueueSnackbar(intl.get('copy_invi_success'), {
					variant: 'success',
				}
			)
		};

		return (
			<div>
				<div className={classes.title}>
					<h2>{intl.get('subscribe')}: </h2>
				</div>
				<div style={{padding: "8px"}}>
					{this.state.isVip === 'star' ?
						null
						:
						<GridContainer>
							<GridItem xs={12} sm={8} md={8} lg={8}>
								<Card blog style={{padding: '16px', backgroundColor: '#DFEAFF'}}>
									{intl.get("subscribe_inviting")}

									<GridItem xs={6} sm={4} md={4} lg={4}>
										<Button color="primary"
												onClick={this.openDialog}
												style={{marginTop: '16px', marginLeft: '-16px'}}>
											{intl.get("subscribe_button")}
										</Button>
									</GridItem>

								</Card>
							</GridItem>

						</GridContainer>

					}
					{/*<GridContainer>*/}
					{/*	<GridItem xs={6} sm={4} md={4} lg={4} style={{marginBottom: '8px'}}>*/}
					{/*		<span style={{*/}
					{/*			fontSize: '16px',*/}
					{/*			color: '#9d9ca2'*/}
					{/*		}}>{intl.get("subscribe_plan")}</span>:*/}
					{/*	</GridItem>*/}
					{/*	<GridItem xs={6} sm={8} md={8} lg={8}>*/}
					{/*		<b>---</b>*/}
					{/*	</GridItem>*/}
					{/*</GridContainer>*/}
					{/*<GridContainer>*/}
					{/*	<GridItem xs={6} sm={4} md={4} lg={4} style={{marginBottom: '8px'}}>*/}
					{/*		<span style={{*/}
					{/*			fontSize: '16px',*/}
					{/*			color: '#9d9ca2'*/}
					{/*		}}>{intl.get("subscribe_price")}</span>:*/}
					{/*	</GridItem>*/}
					{/*	<GridItem xs={6} sm={8} md={8} lg={8}>*/}
					{/*		<b>999/12y</b>*/}
					{/*	</GridItem>*/}
					{/*</GridContainer>*/}
					<GridContainer>
						<GridItem xs={6} sm={4} md={4} lg={4} style={{marginBottom: '8px'}}>
							<span style={{
								fontSize: '16px',
								color: '#9d9ca2'
							}}>{intl.get("subscribe_status")}</span>:
						</GridItem>
						<GridItem xs={6} sm={8} md={8} lg={8}>
							{
								this.state.isVip === 'star' ?
									<b style={{
										fontSize: '16px'
									}}
									>{intl.get("subscribe_active")}</b>
									:
									<Rose><b style={{
										fontSize: '16px'
									}}>{intl.get("subscribe_inactive")}</b></Rose>
							}
						</GridItem>
					</GridContainer>
					<GridContainer>
						<GridItem xs={6} sm={4} md={4} lg={4} style={{marginBottom: '8px'}}>
							<span style={{
								fontSize: '16px',
								color: '#9d9ca2'
							}}>{intl.get("subscribe_block")}</span>:
						</GridItem>
						<GridItem xs={6} sm={8} md={8} lg={8}>
							<b>{this.state.endDate}</b>
						</GridItem>
					</GridContainer>

					<GridContainer>
						<GridItem xs={6} sm={4} md={4} lg={4}>
							<Button color="rose" href={'/plans'}>
								{intl.get("subscribe_more")}
							</Button>
						</GridItem>
					</GridContainer>

					{this.state.isVip === 'star'
						?
						<GridContainer>
							<Card blog style={{padding: '16px', backgroundColor: "#f5f5f5"}}>
								<GridContainer>

									<GridItem xs={6} sm={4} md={4} lg={4}>
										<SVG src={this.state.imgSvg}
											 style={{
												 maxHeight: '160px', maxWidth: '230px'
											 }}
										/>
									</GridItem>
									<GridItem xs={6} sm={8} md={8} lg={8}
											  style={{marginTop: "-0px"}}>
										<GridContainer>
											<b style={{fontSize: '20px'}}>{intl.get("subscribe_button")}</b>
										</GridContainer>
										<GridContainer>
											<span style={{
												fontSize: '16px',
												marginTop: '16px'
											}}>{intl.get("subscribe_inviting")}</span>
										</GridContainer>

										<GridContainer style={{marginTop: '32px'}}>
											<Button
												onClick={this.openDialog}
												color={"rose"}>{intl.get("subscribe_share")}</Button>
										</GridContainer>
									</GridItem>
								</GridContainer>
							</Card>
						</GridContainer>

						:
						null
					}

				</div>

				<Dialog
					classes={{
						root: classes.modalRoot,
						paper: classes.modal
					}}
					open={this.state.showDialog}
					TransitionComponent={Transition}
					keepMounted
					onClose={this.closeDialog}
					aria-labelledby="notice-modal-slide-title"
					aria-describedby="notice-modal-slide-description"
				>
					<DialogTitle
						id="notice-modal-slide-title"
						disableTypography
						className={classes.modalHeader}
					>
						<Button
							simple
							className={classes.modalCloseButton}
							key="close"
							aria-label="Close"
							onClick={this.closeDialog}
						>
							{" "}
							<Close style={{color: '#000'}} className={classes.modalClose}/>
						</Button>
						<h4 className={classes.modalTitle}>
							通过邀请好友获得免费会员?
						</h4>
					</DialogTitle>
					<DialogContent
						id="notice-modal-slide-description"
						className={classes.modalBody}
					>
						<Instruction
							title="1. 邀请码"
							text={
								<span>
									首先<b><a onClick={copyInvite} style={{
									"cursor": "pointer"
								}}>复制</a></b>你的邀请码&nbsp;
									<b>{this.props.data.invitationCode}</b>, &nbsp;将你的邀请码提供你的朋友.
                       			 </span>
							}
							image={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/images/sub_img_1.png'}
							className={classes.instructionNoticeModal}
							imageClassName={classes.imageNoticeModal}
						/>
						<Instruction
							title="2. 注册"
							text={
								<span>
                          		当你的好友注册账号的时候, 填写你所提供的邀请码.
                        </span>
							}
							image={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/images/sub_img_2.png'}
							className={classes.instructionNoticeModal}
							imageClassName={classes.imageNoticeModal}
						/>
						<p>
							<b>注意: </b> 只有你邀请的好友成功验证邮箱后才可获得7天的会员资格
						</p>
					</DialogContent>
					<DialogActions
						className={
							classes.modalFooter + " " + classes.modalFooterCenter
						}
					>
						<Button
							onClick={this.closeDialog}
							color="rose"
							round
						>
							知道了
						</Button>
					</DialogActions>
				</Dialog>

			</div>


		);
	}
}

export default (withSnackbar)(withStyles(styles)(AccountSubscribe))